<template>
  <div class="crm-discount">
    <p class="font-weight-bold mb-1">Знижка в нагадуванні про списання</p>
    <p class="grey--text mb-3">
      Коли увімкнено, у листі за 3 дні і в боті за день до списання психолог бачить кнопку «Перейти на {{ amountText }} на місяць».
      Після підтвердження сума його підписки WayForPay змінюється, картка і дата списання ті самі. Нова сума лишається і після кінця акції.
      Кнопку бачать лише ті, хто платить через WayForPay більше за цю суму.
    </p>
    <div class="crm-discount__line">
      <v-switch v-model="form.enabled" label="Увімкнено" hide-details class="mt-0 pt-0"></v-switch>
      <v-text-field v-model.number="form.amount" type="number" min="1" step="0.5" label="Нова сума на місяць" suffix="EUR" outlined dense hide-details class="crm-discount__amount"></v-text-field>
      <v-menu v-model="dateMenu" :close-on-content-click="false" offset-y min-width="auto">
        <template #activator="{ on, attrs }">
          <v-text-field
            :value="untilText"
            label="Кнопку видно до (включно)"
            placeholder="без кінцевої дати"
            readonly
            outlined
            dense
            hide-details
            clearable
            class="crm-discount__until"
            v-bind="attrs"
            v-on="on"
            @click:clear="form.until = null"
          ></v-text-field>
        </template>
        <v-date-picker v-model="form.until" no-title locale="uk-UA" :first-day-of-week="1" :min="today" @change="dateMenu = false"></v-date-picker>
      </v-menu>
      <v-btn depressed color="primary" :loading="saving" @click="save">Зберегти</v-btn>
      <span v-if="saved" class="green--text">Збережено</span>
    </div>
    <p v-if="error" class="red--text caption mt-2 mb-0">{{ error }}</p>
  </div>
</template>

<script>
import ApiClient from "@/libs/http-client";

export default {
  name: "CrmDiscount",
  data() {
    return {
      form: { enabled: false, amount: 15, until: null },
      dateMenu: false,
      saving: false,
      saved: false,
      error: "",
      today: new Date().toISOString().slice(0, 10),
    };
  },
  computed: {
    amountText() {
      return `${this.form.amount || 15} EUR`;
    },
    untilText() {
      if (!this.form.until) return "";
      const [y, m, d] = this.form.until.split("-");
      return `${d}.${m}.${y}`;
    },
  },
  mounted() {
    ApiClient.get("api/admin/crm/subscription-discount").then((response) => {
      this.form = response.data.data;
    });
  },
  methods: {
    save() {
      this.saving = true;
      this.saved = false;
      this.error = "";
      ApiClient.post("api/admin/crm/subscription-discount", this.form)
        .then((response) => {
          this.form = response.data.data;
          this.saved = true;
        })
        .catch((error) => {
          this.error = (error && error.message) || "Не вдалося зберегти";
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.crm-discount {
  margin: 16px 0 24px;
  padding: 16px;
  border: 1px solid #e3eef0;
  border-radius: 8px;
  background: #f7fbfc;
  &__line {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;
  }
  &__amount {
    flex: 0 0 190px;
  }
  &__until {
    flex: 0 0 240px;
  }
}

@media (max-width: 900px) {
  .crm-discount {
    &__amount,
    &__until {
      flex: 1 1 100%;
    }
    // iOS zooms the page on a smaller field
    ::v-deep input {
      font-size: 16px;
    }
  }
}
</style>
